/**
 * What a MANAGER may reach, decided per organisation by the admin (Settings → Manager access).
 *
 * These name SURFACES, not permissions. `employees` is "the Employees menu", not "may read an
 * employee" — a manager still loads their team's employees for the pages they keep. Only
 * `attendanceDetailEdit` guards a write, and that one is enforced by the API as well; the other
 * two hide menus and block their routes, which is a UI decision rather than a security boundary.
 *
 * The first three default to 1. A missing response means "everything allowed", the same as an
 * organisation that has never opened the screen.
 *
 * `biometricOt` defaults to 0, which reads as an inconsistency and is not one. The other three
 * REMOVE a menu managers already have, so on-by-default means "unchanged". This one GRANTS a
 * report they have never had, so on-by-default would mean every manager in every biometric org
 * finding a new payroll report in their sidebar after a release. It is also the only switch the
 * screen hides entirely for non-biometric orgs, which have no such report to reach.
 *
 * `attendanceBreakdown` is the second granting switch and follows `biometricOt`: the Payable & LOP
 * popup on the Attendance Report detail page is admin-only, so on-by-default would show pay figures
 * to every manager in every payroll org after a release. The screen hides it for non-payroll orgs,
 * and the API enforces it as well as the button.
 */
export interface IManagerAccess {
  leavePermission: number;
  employees: number;
  attendanceDetailEdit: number;
  biometricOt: number;
  attendanceBreakdown: number;
  // The OT money value on the Overtime reports (2026-10-27). Defaults to 0 like biometricOt:
  // it grants a salary-derived figure managers never had, so it must not appear on deploy day.
  otAmount: number;
}

export const MANAGER_ACCESS_DEFAULT: IManagerAccess = {
  leavePermission: 1,
  employees: 1,
  attendanceDetailEdit: 1,
  biometricOt: 0,
  attendanceBreakdown: 0,
  otAmount: 0,
};
